// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"8fdb0809","885":"3977cef0","977":"0b9402d9"}[chunkId] + ".chunk.js";
};